export default __webpack_public_path__ + "static/media/video.1dc4d270.mp4";